import { DateTime } from 'luxon';
import { usePledgePotViewCreator } from '@viewCreators/pledge-pot-view-creator';
import { useMemo } from 'react';

export const usePotCard2Controller = (groupId: number, groupStartDate?: DateTime) => {
  const DAY_8 = 8;
  const { data, isLoading, refetch, isFetching, isPending } = usePledgePotViewCreator(groupId);
  const message = 'Keep showing up, and this piece of the program will be revealed before you know it.';

  const enabled = useMemo(() => {
    if (!groupStartDate) {
      return false;
    } else {
      // Pot: Should be active starting on day 8 (Monday of week 1, the first exercise week)
      const daysFromStart = groupStartDate.diffNow('days').days;
      return Math.ceil(Math.abs(daysFromStart)) >= DAY_8;
    }
  }, [groupStartDate]);

  return {
    potValue: Intl.NumberFormat('en-US', {
      currency: 'USD',
      style: 'currency',
    }).format(data?.potValue || 0),
    pledgeAmount: Intl.NumberFormat('en-US', {
      currency: 'USD',
      style: 'currency',
    }).format(data?.pledgeAmount || 0),
    remainingPledgeAmount: Intl.NumberFormat('en-US', {
      currency: 'USD',
      style: 'currency',
    }).format(data?.remainingPledgeAmount || 0),
    enabled,
    disabledMessage: message,
    isLoading,
  };
};
